import useBootstrapData from '@/hooks/useBootstrapData'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import type { RecentFlightSearches, RecentTripSearches } from '../types'

function hasRecentSearchFlightData(
  data: ReadonlyArray<RecentTripSearches>
): data is ReadonlyArray<RecentFlightSearches> {
  return data[0]?.productType === 'FLY'
}

export default function useGetMostRecentFlightSearch() {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn }
  } = useBootstrapData()

  const mostRecentFlightSearchData = useRecentSearchCard(
    clientGUID,
    { appName, appVersion },
    ['FLY'],
    signedIn
  )

  if (!hasRecentSearchFlightData(mostRecentFlightSearchData)) {
    return []
  }

  return mostRecentFlightSearchData
}
